import { FGSelectInput, IFGSelectInputProps } from "nsitools-react";
import * as React from "react";
import { useCommonHooks } from "../../hooks";
import { useFunctionalDirectorRef } from "../../hooks/applicationHooks/useFunctionalDirectorRef";
import { ReferentialItemDto } from "../../api";
import { nameof } from "../../utils";

export interface IFunctionalDirectorSelectProps
  extends Pick<
    IFGSelectInputProps<any>,
    "requiredMark" | "visible" | "disabled" | "style" | "readonly"
  > {
  name: string;
  label?: string;
  loading?: boolean;
}
export const FunctionalDirectorSelect: React.FunctionComponent<
  IFunctionalDirectorSelectProps
> = ({ name, label, loading = false, ...fgSelectInputProps }) => {
  const { t } = useCommonHooks();
  const { dir, dirLoading } = useFunctionalDirectorRef();

  return (
    <FGSelectInput
      label={label || t("FunctionalDirectorName")}
      name={name}
      items={dir}
      loading={dirLoading || loading}
      displayField={nameof<ReferentialItemDto>("displayValue")}
      valueField={nameof<ReferentialItemDto>("idValue")}
      isFilterable={true}
      {...fgSelectInputProps}
    />
  );
};

export default FunctionalDirectorSelect;
